import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

const initialState = {
    hasAttachments: false,
    attachments:[]
}

const hasAttachmentsSlice = createSlice({
    name: 'attachment',
    initialState,
    reducers:{
        setHasAttachments: (state, action) => {
            state.hasAttachments = action.payload;
        },
        setAttachments: (state, action) =>{
            state.attachments = action.payload;
        }
    }
});

export const { setHasAttachments, setAttachments } = hasAttachmentsSlice.actions;
export default hasAttachmentsSlice.reducer; 